import * as React from "react";
import { HistoryCard } from "../../HistoryCard";
import { BrakeDiscIcon, IconComponent, Text, TextVariant } from "../../../ui";

/**
 * One Carfax record, laid out like the inspection card: a header bar with when (and the job or record type),
 * then one row per item with dividers.
 */
export const RecordCard: React.FC<{
  title: string;
  aside?: React.ReactNode;
  rows: string[];
  /** Marks each row; each source has its own, so NuBrakes work and Carfax entries read apart at a glance. */
  RowIcon: IconComponent;
  /** Rows to call out at their end with a blue brake disc. */
  isFlagged?: (row: string) => boolean;
  id?: string;
  highlighted?: boolean;
}> = ({ title, aside, rows, RowIcon, isFlagged, id, highlighted }) => (
  <HistoryCard title={title || "No date"} aside={aside} id={id} highlighted={highlighted}>
    <div role="list" className="px-3 py-1">
      {rows.map((row, index) => (
        <div
          role="listitem"
          key={index}
          className="py-2 border-b border-[#44576e] last:border-b-0 flex items-start gap-2"
        >
          <RowIcon aria-hidden style={{ fontSize: "1.125rem", color: "#94a3b8", flexShrink: 0, marginTop: 3 }} />
          <Text variant={TextVariant.BODY1} style={{ fontWeight: 600, flex: 1 }}>
            {row}
          </Text>
          {isFlagged?.(row) && (
            <span role="img" aria-label="Brake work" title="Brake work" className="flex shrink-0">
              <BrakeDiscIcon style={{ fontSize: "1.25rem", color: "#3b82f6", marginTop: 2 }} />
            </span>
          )}
        </div>
      ))}
    </div>
  </HistoryCard>
);
